module.exports = "query Categories {\n  categories {\n    id\n    name\n  }\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/graphQL/queries/Categories.graphql
// module id = qKT3
// module chunks = 1624